import React from 'react'
import {Switch, FormControlLabel} from '@mui/material'
import {useSelector} from 'react-redux'
import {spaceSmall} from '../../assets/styles/spacing'
import {CORE_FEATURE_AMENITIES} from '../../constants/ModelConstants'
import SimpleSpinner from '../SimpleSpinner'

function parseDisabledFeatures(disabledFeatures) {
  if (Array.isArray(disabledFeatures)) {
    return disabledFeatures
  }

  if (typeof disabledFeatures === 'string') {
    try {
      const parsedDisabledFeatures = JSON.parse(disabledFeatures)
      return Array.isArray(parsedDisabledFeatures) ? parsedDisabledFeatures : []
    } catch (err) {
      console.error(err)
    }
  }

  return []
}

function buildingHasFeatureEnabled(building, feature) {
  return !parseDisabledFeatures(building?.disabledFeatures).includes(feature)
}

function NotificationSettings({
  stagedNotifyEveryMessage,
  stagedNotifyWithDelay,
  stagedNotifyWith24HourDelay,
  stagedNotifyAmenityReservationRequests,
  stagedNotifyOnboardingItemsToReviewWithDelay,
  stagedNotifyNewOnboardingItemToReview,
  isLoadingNotificationSettings,
  setStagedNotifyEveryMessage,
  setStagedNotifyWithDelay,
  setStagedNotifyWith24HourDelay,
  setStagedNotifyAmenityReservationRequests,
  setStagedNotifyOnboardingItemsToReviewWithDelay,
  setStagedNotifyNewOnboardingItemToReview,
  loadNotificationSettingsError,
  permissionsObject,
}) {
  const buildings = useSelector(state => Object.values(state.Buildings.buildingsLookup))
  const hasAmenityNotifications = buildings.some(building => buildingHasFeatureEnabled(building, CORE_FEATURE_AMENITIES))
  const hasOnboardingNotifications = buildings.some(building => !!building.onboardingSchema)

  if (isLoadingNotificationSettings) {
    return <SimpleSpinner size={SimpleSpinner.SIZE_DEFAULT} />
  } else if (loadNotificationSettingsError) {
    return <div>{loadNotificationSettingsError}</div>
  }

  return (
    <div style={{display: 'flex', flexDirection: 'column', gap: spaceSmall, maxWidth: 600}}>
      {permissionsObject.messagesWrite && (
        <React.Fragment>
          <FormControlLabel
            control={
              <Switch
                checked={stagedNotifyEveryMessage}
                onChange={() => setStagedNotifyEveryMessage(!stagedNotifyEveryMessage)}
                color="primary"
              />
            }
            label="Notify for every new RXO Chat message"
          />

          <FormControlLabel
            control={
              <Switch checked={stagedNotifyWithDelay} onChange={() => setStagedNotifyWithDelay(!stagedNotifyWithDelay)} color="primary" />
            }
            label="Notify for RXO Chat message with 36 hour delay"
          />

          <FormControlLabel
            control={
              <Switch
                checked={stagedNotifyWith24HourDelay}
                onChange={() => setStagedNotifyWith24HourDelay(!stagedNotifyWith24HourDelay)}
                color="primary"
              />
            }
            label="Notify for RXO Chat message with 24 hour delay"
          />
        </React.Fragment>
      )}

      {hasAmenityNotifications && (
        <FormControlLabel
          control={
            <Switch
              checked={stagedNotifyAmenityReservationRequests}
              onChange={() => setStagedNotifyAmenityReservationRequests(!stagedNotifyAmenityReservationRequests)}
              color="primary"
            />
          }
          label="Notify for amenity reservation requests"
        />
      )}

      {hasOnboardingNotifications && (
        <React.Fragment>
          <FormControlLabel
            control={
              <Switch
                checked={stagedNotifyNewOnboardingItemToReview}
                onChange={() => setStagedNotifyNewOnboardingItemToReview(!stagedNotifyNewOnboardingItemToReview)}
                color="primary"
              />
            }
            label="Notify for Onboarding Items to Review"
          />

          <FormControlLabel
            control={
              <Switch
                checked={stagedNotifyOnboardingItemsToReviewWithDelay}
                onChange={() => setStagedNotifyOnboardingItemsToReviewWithDelay(!stagedNotifyOnboardingItemsToReviewWithDelay)}
                color="primary"
              />
            }
            label="Notify for Onboarding Items to Review with 36 hour delay"
          />
        </React.Fragment>
      )}
    </div>
  )
}

export default NotificationSettings
